import React from 'react'
import { ReactElement } from 'react'
import styled from 'styled-components'

import Badge from '../../../../../../../../../1stlog-ui/src/components/Badge'
import Country from '../../../../../../../../../1stlog-ui/src/components/Country'
import Currency from '../../../../../../../../../1stlog-ui/src/components/Currency'
import { formatDecimal } from '../../../../../../../../../1stlog-ui/src/components/Field/format'
import { TOrderEntryAutocompleteCustomsItem } from '../../../../types'

const Wrapper = styled.div`
  cursor: pointer;
`

type TOptionProps = {
  item: TOrderEntryAutocompleteCustomsItem
}

const Option = (props: TOptionProps): ReactElement => {
  const {
    item: {
      articleNumber,
      originCountry,
      description,
      value,
      valueCurrency,
      tariffNumber,
      // exporttariffNumber,
      netWeight,
      grossWeight,
    },
  } = props

  return (
    <Wrapper>
      <div className="d-flex align-items-center">
        <Badge info>Art. Nr./Referenz: {articleNumber}</Badge>&nbsp;
        {description}
      </div>
      <div className="d-flex">
        <span className="text-muted">
          {i18n.t('label_country_origin', 'Ursprungsland')}:&nbsp;
        </span>
        <Country country={originCountry} />
      </div>
      <div>
        <span className="text-muted">
          {i18n.t('label_customs_nmb', 'Zolltarifnummer')}:
        </span>{' '}
        {tariffNumber}
      </div>
      <div>
        <span className="text-muted">
          {i18n.t('label_value_goods', 'Warenwert')}:
        </span>{' '}
        <Currency value={value} currency={valueCurrency} />
      </div>
      <div>
        <span className="text-muted">{i18n.t('weight', 'Gewicht')}</span>:{' '}
        {formatDecimal(netWeight, 2)} kg ({formatDecimal(grossWeight, 2)} kg
        Brutto)
      </div>
    </Wrapper>
  )
}

export default Option
